module.exports = __webpack_public_path__ + "f08a205108e4d3e84ec0b3354c152dc5.png";